module.exports = __webpack_public_path__ + "static/media/bg_benefit.f4867667.jpg";